import {Component, Inject} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {EformAPI} from '../../e-form.api';

@Component({
   selector: 'app-delete-form',
   templateUrl: './delete-form.component.html',
   styleUrls: ['./delete-form.component.css']
})
export class DeleteFormComponent {

   disableButton = false;

   constructor(@Inject(MAT_DIALOG_DATA) private data: any,
               private dialogRef: MatDialogRef<DeleteFormComponent>,
               private api: EformAPI) {
   }

   onClickOk() {
      if (this.data.formList.length > 0 && !this.data.formId) {
         for (let i = 0; i < this.data.formList.length; i++) {
            this.deleteFormList(this.data.formList[i].formId);
         }
      } else {
         this.deleteFormList(this.data.formId);
      }
   }

   deleteFormList(formId) {
      this.api.deleteFormList(formId).subscribe((res) => {
         this.disableButton = true;
         this.dialogRef.close({response: true, msg: res});
      });
   }
}
